<template>
  <div>
    <v-toolbar dense flat>
      <v-app-bar-nav-icon small to="/subscription/home">
        <v-icon>home</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>Subscription</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn color="teal" :fab="$vuetify.breakpoint.xsOnly" v-if="checkRightStatus(7)" text dark @click="newInvoice">
        <span v-if="!$vuetify.breakpoint.xsOnly">New</span>
        <v-icon v-else>add</v-icon>
      </v-btn>
      <v-btn color="teal" :fab="$vuetify.breakpoint.xsOnly" text dark to="/subscription/list">
        <span v-if="!$vuetify.breakpoint.xsOnly">List</span>
        <v-icon v-else>list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import recurringInvoiceStore from "./store.js";

export default {
  name: "subscription-home",
  mixins: [RegisterStoreModule],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    ...mapGetters("subscription", ["SubscriptionDetails"]),
  },
  methods: {
    ...mapActions("subscription", ["ResetSubscription"]),
    newInvoice() {
      if (this.SubscriptionDetails.length !== 0) {
        this.$swal({
          title: "Are you sure?",
          text: "There is an running subscription you want to clear it",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#B71C1C",
          cancelButtonColor: "#43A047",
          cancelButtonText: "No",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.value) {
            this.ResetSubscription();
            if (this.CustomerId) {
              this.$router.push({
                path: `/subscription/create?CustomerId=${this.CustomerId}`,
              });
            } else {
              this.$router.push({ path: `/subscription/create` });
            }
          }
        });
      } else {
        if (this.CustomerId) {
          this.$router.push({
            path: `/subscription/create?CustomerId=${this.CustomerId}`,
          });
        } else {
          this.$router.push({ path: `/subscription/create` });
        }
      }
    },
  },
  created() {
    this.registerStoreModule("subscription", recurringInvoiceStore);
  },
};
</script>
